import Select, { Props as ReactSelectProps } from 'react-select';

/**
 * uses react-select to create a custom select component
 * note: you will need to use a controller from react-hook-form to use this component
 * @param props
 * @returns
 */
export const ReactSelect = (props: ReactSelectProps) => {
  return (
    <Select
      styles={{
        control: (styles, { isFocused }) => ({
          ...styles,
          borderRadius: '.5rem',
          border: '1px solid var(--color-slate-200)',
          borderColor: isFocused ? '1px solid var(--color-brand-purple-primary)' : '1px solid var(--color-slate-200)',
          height: '3.5rem',
          paddingLeft: '.5rem',
          lineHeight: '1.5rem', /* 150% */
          fontSize: '1rem',
          fontWeight: '400',
          outline: isFocused ? '1px solid var(--color-brand-purple-primary)' : 'none',
          '&:hover': {
            outline: 'none',
            border: isFocused ? '1px solid var(--color-brand-purple-primary)'
              : '1px solid var(--color-brand-purple-primary)', // Ensure border color stays consistent on hover
          },
        }),
        option: (styles, { isSelected }) => ({
          ...styles,
          paddingLeft: '1.25rem',
          backgroundColor: isSelected ? 'var(--color-brand-blue-primary)' : 'var(--color-white)',
          '&:hover': {
            backgroundColor: 'var(--color-gray-500)',
            color: 'var(--color-white)',
          },
        }),
      }}
      {...props}
    />
  );
};
